import React, { useEffect, useState } from 'react'
import { NewCommonModal, CustomSelect } from 'components'

const UpdateLrDetailsUsingPod = (props) => {

    let { isOpen, closeModal } = props;

    return (
        <div>
            <NewCommonModal {...props}>
                <div className='elemt_pding'>
                    <p className='fontFix_ftn'> Do you want to update POD Values for PO {isOpen?.Po_number ? isOpen?.Po_number : ''} </p>
                    <div className='box_modal_pdo'>
                        <p className='child_box_pod'> <span className='opcityCls'> Quantity </span> <span> {isOpen?.total_qty_in_stn ? isOpen?.total_qty_in_stn : ''} </span> </p>
                        <p className='child_box_pod'> <span className='opcityCls'>Total KOT </span> <span> {isOpen?.total_kot ? isOpen?.total_kot : ''} </span> </p>
                        <p className='child_box_pod'> <span className='opcityCls'>POD (GAN Number) </span> <span> {isOpen?.pod_number ? isOpen?.pod_number : ''} </span> </p>
                        <p className='child_box_pod'> <span className='opcityCls'>Invoice Number </span> <span> {isOpen?.invoice_number ? isOpen?.invoice_number : ''} </span> </p>
                    </div>
                </div>
            </NewCommonModal>
            <div className='offBack_drop'></div>
        </div>
    )
}

export default UpdateLrDetailsUsingPod
